import { IUsersApi } from '@vivli/features/users/infrastructure/interface';
import { IVivliConfigurationApi } from '@vivli/shared/infrastructure/interface';
import { useActiveUser, useVivliConfig } from '../core';
import { useMyDataRequestsApi } from '../api';
import { IDataRequestsApi } from '@vivli/features/data-requests/infrastructure/interface';
import { IPlatformContextHooks } from '@vivli/core/infrastructure/interface';
import { useExternalMenuItemsInit } from './use-external-menu-items-init.hook';
import { useDataRequestPermissions } from './use-data-request-permissions.hook';
import { useDataRequestFilters } from './use-data-request-filters.hook';
import { useMemo } from 'react';

export interface IUseContextInitParams {
    usersApi: IUsersApi;
    vivliConfigApi: IVivliConfigurationApi;
    dataRequestsApi: IDataRequestsApi;
}

export const useContextInit = ({ usersApi, vivliConfigApi, dataRequestsApi }: IUseContextInitParams): IPlatformContextHooks => {
    const activeUser = useActiveUser({ usersApi });
    const dataRequestPermissions = useDataRequestPermissions(activeUser);
    const dataRequestFilters = useDataRequestFilters(dataRequestPermissions);
    const vivliConfig = useVivliConfig({ vivliConfigApi, activeUser });
    const myDataRequestsApi = useMyDataRequestsApi({ activeUser, dataRequestsApi });
    const externalLinks = useExternalMenuItemsInit(vivliConfigApi);

    return useMemo(
        () => ({
            activeUser,
            vivliConfig,
            myDataRequestsApi,
            externalLinks,
            dataRequestPermissions,
            dataRequestFilters
        }),
        [activeUser, vivliConfig, myDataRequestsApi, externalLinks, dataRequestPermissions, dataRequestFilters]
    );
};
